var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M496 107.5c-18 7.5-36 13.5-56.8 15 21-12 36-31.5 43.3-54-19.4 12-40.3 19.5-62.8 24C401.7 73 376.4 61 349.5 61c-54 0-98.7 43.5-98.7 99 0 7.5 1.5 15 3 22.5C171.5 178 99.8 139 50.4 79c-9 15-13.5 31.5-13.5 49.5C37 163 55 193 80.2 211c-16.4 0-31.4-4.5-45-12v1.5c0 48 34.5 87 79.4 96-9 1.5-16.5 3-25.4 3-6 0-12 0-18-1.5 12 39 49.4 67.5 91.2 69-33 27-76.2 42-122.6 42-7.6 0-16.5 0-24-1.5 45 27 97.2 43.5 152.5 43.5 181 0 279.6-150 279.6-280.5v-12c18-15 34.5-31.5 48-51z","fill":"#1da1f2"}));
}

Twitter.defaultProps = {"viewBox":"0 0 512 512","height":"512","width":"512"};

module.exports = Twitter;

Twitter.default = Twitter;
